import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import axios from 'axios';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { createOrder } from '../../../common/api/clients/order.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const useDraftCreate = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { addErrorToast } = useToasts();

    return useMutation({
        mutationFn: createOrder,
        onSuccess: (response) => {
            queryClient.removeQueries({ queryKey: queries.orders._def });

            navigate({ to: '/orders/draft/$id', params: { id: response.id }, replace: true });
        },
        onError: (error) => {
            if (axios.isAxiosError(error) && error.response?.status === 400) {
                addErrorToast(translate('order.validationFailedToast'));
                return;
            }
            addErrorToast(translate('alert.defaulterror.message'));
        },
    });
};
